'use client';

import { Suspense } from 'react';
import { BlogSearchPage } from '@/components/pages/blog/BlogSearchPage';
import { useAppNavigate } from '../_lib/useAppNavigate';

function BlogSearchInner() {
  const navigate = useAppNavigate();
  return <BlogSearchPage onNavigate={navigate} />;
}

export default function BlogSearchClient() {
  return (
    <Suspense fallback={null}>
      <BlogSearchInner />
    </Suspense>
  );
}
